import { ROLES } from './constants';

const isOfRole = (el, role) => el && el.type.role === role;

export function isTab(el) {
  return isOfRole(el, ROLES.TAB);
}

export function isTabList(el) {
  return isOfRole(el, ROLES.TAB_LIST);
}

export function isTabPanel(el) {
  return isOfRole(el, ROLES.TAB_PANEL);
}
